module.exports = __webpack_public_path__ + "img/beyond-heaven-and-earth--a-cognitive-theory-of-religion-cover.5135db8e.jpg";